<template>
  <div>
    <router-link
      v-if="!loading"
      :to="`/sport/${sport.id}`"
      @mouseenter="showIcons = true"
      @mouseleave="showIcons = false"
      :class="[
        'w-full min-h-35 mt-1 rounded-md flex items-center space-x-3 text-left transition-colors outline-none focus:outline-none',
        sport.isActive
          ? 'bg-illinois-secondary text-illinois-primary'
          : ' text-illinois-text-muted hover:text-illinois-primary'
      ]"
    >
      <SportIcons :sportId="sport.icon_id.toString()" />
      <span class="text-sm font-bold flex-1 text-illinois-text">{{
        sport.name
      }}</span>

      <IllinoisIcons
        v-if="sport.hasSubmenu && (showIcons || openSportsSubmenu)"
        icon="chevron-down"
        class="w-3 h-3 text-illinois-text-secondary transform transition-transform duration-300"
        :class="{ 'rotate-180': openSportsSubmenu }"
        :width="12"
        :height="12"
      />
    </router-link>

    <!-- Skeleton placeholder -->
    <div
      v-else
      class="w-full min-h-35 mt-1 rounded-md flex items-center space-x-3 text-left bg-transparent"
    >
      <div
        class="w-5 h-5 bg-illinois-white-20 rounded-full shimmer text-illinois-white-40"
      ></div>
      <div
        class="h-4 rounded bg-illinois-white-20 shimmer text-illinois-white-40"
        style="width: 120px"
      ></div>
    </div>

    <!-- Sottomenu per sport con hasSubmenu -->
    <div
      v-if="sport.hasSubmenu && openSportsSubmenu"
      class="ml-2 mt-1 space-y-1"
    >
      <button
        v-for="subSport in sport.submenu"
        :key="subSport.id"
        @click="onSubSportClick(subSport)"
        class="w-full p-2 rounded-md flex items-center space-x-3 text-left transition-colors hover:text-illinois-primary text-illinois-text-muted outline-none focus:outline-none"
      >
        <SportIcons :sportId="subSport.icon_id.toString()" />
        <span class="text-sm font-bold">{{ subSport.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import IllinoisIcons from '../icons.vue';
import SportIcons from '../SportIcons.vue';
export default {
  name: 'SidebarItem',
  components: {
    IllinoisIcons,
    SportIcons
  },
  props: {
    sport: {
      type: Object,
      required: false,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openSportsSubmenu: false,
      showIcons: false
    };
  },
  methods: {
    /* onSportClick() {
      // Se ha un sottomenu, gestisci l'apertura/chiusura
      if (this.sport.hasSubmenu) {
        this.openSportsSubmenu = !this.openSportsSubmenu;
      } else {
        // Altrimenti emetti evento al parent con i dati dello sport
        this.$emit('sport-selected', this.sport);
      }
    },
    onSubSportClick(subSport) {
      // Emetti evento al parent con i dati del sotto-sport
      this.$emit('sport-selected', subSport);
    } */
  }
};
</script>

<style scoped>
button {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

button:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

button:active {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

button:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
</style>
